import React, { useEffect } from 'react';
import { List, Datagrid, FunctionField } from 'react-admin';

function QuienesSomosList(props: any) {
  useEffect(() => {
    document.title = 'Quienes Somos - Gasco';
  }, []);

  return (
    <List {...props}>
      <Datagrid rowClick="edit">
        <FunctionField
          label="Descripción"
          render={(record: any) => {
            const text = record.descripcion?.[0]?.children?.[0]?.text || '';
            return <span>{text.substring(0, 70)}...</span>;
          }}
        />
        <FunctionField
          label="Directorio"
          render={(record: any) => {
            const text = record.directorio?.[0]?.children?.[0]?.text || '';
            return <span>{text.substring(0, 70)}...</span>;
          }}
        />
      </Datagrid>
    </List>
  );
}

export default QuienesSomosList;
